(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  function setup(section){
    const bg = section.querySelector('.custom-section-background');
    if (!bg) return;

    // Controls from data-*
    const travelVh = parseFloat(section.dataset.travelVh || '12');     // depth
    const offsetYVh = parseFloat(section.dataset.offsetYVh || '0');    // base Y
    const offsetXVh = parseFloat(section.dataset.offsetXVh || '0');    // base X
    const clampPct = parseFloat(section.dataset.clamp || '60');        // 20..100
    const scalePct = parseFloat(section.dataset.scale || '120');       // 105..150

    const vhPx = () => (window.innerHeight || 0) / 100;
    const travelPx = () => vhPx() * travelVh;
    const offsetYPx = () => vhPx() * offsetYVh;
    const offsetXPx = () => vhPx() * offsetXVh;

    const clampAmt = clamp(clampPct / 100, 0.2, 1); // 0.2..1
    const scale = clamp(scalePct / 100, 1.05, 1.5);

    let targetY = 0;
    let currentY = 0;
    let raf = null;

    function computeTarget(){
      const r = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;

      // progress 0..1 as section passes viewport
      const total = vh + r.height;
      const p = clamp((vh - r.top) / total, 0, 1);

      // -1..+1 centered
      const centered = (p - 0.5) * 2;

      // limit excursion (prevents going too far “under”)
      const limited = clamp(centered, -clampAmt, clampAmt);

      // base offset + parallax
      targetY = offsetYPx() + (limited * travelPx());
    }

    function tick(){
      raf = null;

      // cinematic smoothing
      currentY += (targetY - currentY) * 0.08;

      bg.style.transform = `translate3d(${offsetXPx()}px, ${currentY}px, 0) scale(${scale})`;

      if (Math.abs(targetY - currentY) > 0.25){
        raf = requestAnimationFrame(tick);
      }
    }

    function requestTick(){
      if (!raf) raf = requestAnimationFrame(tick);
    }

    function onScroll(){
      computeTarget();
      requestTick();
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll);
  }

  function init(){
    document.querySelectorAll('.section[data-ww-parallax]').forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
